module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Gd-Da-Ea.b5f5515c.png";